import _regeneratorRuntime from "/Users/riverlei/project/java/bgyy-project/front-admin/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/Users/riverlei/project/java/bgyy-project/front-admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "/Users/riverlei/project/java/bgyy-project/front-admin/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _createForOfIteratorHelper from "/Users/riverlei/project/java/bgyy-project/front-admin/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import dayjs from 'dayjs';
export default {
  name: 'logistics_waybill_order',
  components: {
    merchantEvalDialog: function merchantEvalDialog() {
      return import('./merchant/merchant_eval_dialog');
    },
    driverSel: function driverSel() {
      return import('./driver/driver_sel');
    }
  },
  data: function data() {
    return {
      dayjs: dayjs,
      pageConfig: {
        editPageName: '运单',
        modifyFunName: 'logisticHongdeWaybillOrderModify',
        queryFunName: 'logisticHongdeWaybillOrderQuery',
        detailOrderFunName: 'logisticHongdeWaybillOrderDetail',
        waybillOrderConfirmFunName: 'logisticHongdeWaybillOrderConfirm',
        detailFunName: 'logisticHongdeWaybillDetail',
        dicTreeFunName: 'mngDictionaryLowerTree',
        shipCompanyDetailFunName: 'logisticHongdeShipCompanyDetail',
        totalFeeFunName: 'logisticHongdeWaybillOrderFeeTotal',
        driverDetailFunName: 'logisticHongdeDriverDetail',
        undoFunName: 'logisticHongdeWaybillOrderUndo',
        firstPlaceFunName: 'logisticHongdeWaybillOrderFirstPlace',
        secondPlaceFunName: 'logisticHongdeWaybillOrderSecondPlace',
        thirdPlaceFunName: 'logisticHongdeWaybillOrderThirdPlace',
        transferFunName: 'logisticHongdeWaybillOrderTransfer',
        transferCancelFunName: 'logisticHongdeWaybillOrderTransferCancel',
        placeFeeFunName: 'logisticHongdeWaybillOrderPlaceFee',
        mngConfigCacheValue: 'mngConfigCacheValue',
        secondArriveFunName: 'logisticHongdeWaybillOrderSecondArrive',
        platformConfim: 'logisticHongdeWaybillOrderPlatform',
        logisticHongdeWaybillOrderBillsAndImage: 'logisticHongdeWaybillOrderBillsAndImage'
      },
      searchForm: {
        page: 1,
        limit: 10,
        searchKey: null,
        sortField: 'create_time',
        merchantNickname: null,
        driverContactPhone: null,
        waybillDeliveryMode: null,
        starDate: null,
        endDate: null,
        orderState: null,
        waybillExtractIdentity: null
      },
      formData: {
        id: null,
        firstContainerIdentity: null,
        firstContainerSealIdentity: null,
        secondContainerIdentity: null,
        secondContainerSealIdentity: null,
        transportAmount: null
      },
      queryLoading: true,
      tableData: [],
      totalCount: 0,
      editDialogShow: false,
      editDialogTitle: '',
      detailDialogShow: false,
      formLabelWidth: '100px',
      emptyFormData: {},
      waybillDetailData: {
        id: null,
        cradleAddress: null,
        cradleLbs: null,
        cradleBeginTime: null,
        cradleLastTime: null,
        assembleAddress: null,
        assembleLbs: null,
        assembleBeginTime: null,
        assembleLastTime: null,
        purposeAddress: null,
        purposeLbs: null,
        purposeBeginTime: null,
        purposeLastTime: null,
        shipCompanyId: null,
        shipRemark: null,
        specifyCarTeamIds: null
      },
      waybillOrderDetailData: {},
      dicData: {
        sizeUpperCode: 'logistics_hd_container_size',
        configSizes: [],
        configSizeOptions: {},
        shapeUpperCode: 'logistics_hd_container_shape',
        configShapes: [],
        configShapeOptions: {}
      },
      totalFeeFormData: {
        freightCost: null,
        serviceFeeCost: null
      },
      driverDetailData: {
        carNumber: null,
        name: null,
        contactPhone: null
      },
      orderState: {
        Wait: {
          label: '待接单',
          value: 'Wait'
        },
        Accept: {
          label: '已接单',
          value: 'Accept'
        },
        First_Place_Confirm: {
          label: '提箱确认',
          value: 'First_Place_Confirm'
        },
        Second_Place_Arrive: {
          label: '抵达卸货地',
          value: 'Second_Place_Arrive'
        },
        Second_Place_Confirm: {
          label: '卸货/送货确认',
          value: 'Second_Place_Confirm'
        },
        Third_Place_Confirm: {
          label: '收箱确认',
          value: 'Third_Place_Confirm'
        },
        Merchant_Confirm: {
          label: '已结案',
          value: 'Merchant_Confirm'
        },
        Undo: {
          label: '已撤单',
          value: 'Undo'
        },
        Refuse: {
          label: '转单拒绝',
          value: 'Refuse'
        },
        back_address: {
          label: '返箱回提箱地确认',
          value: 'back_address'
        },
        driver_finish: {
          label: '返箱回提箱地完成',
          value: 'driver_finish'
        }
      },
      confirm_params: {
        firstPlaceFee: null,
        firstPlaceImage: []
      },
      confirmDialogShow: false,
      confirmDialogTitle: '',
      currentMerchant: {},
      eval_show: false,
      driver_show: false,
      containerSealNums: [],
      place_params: {
        "firstPlaceFee": null,
        "secondPlaceFee": null,
        "thirdPlaceFee": null,
        "id": null
      },
      placeDialogShow: false,
      service_fee_scale: 0,
      dialogData: {},
      dialogOrderData: {},
      otherImageDialogShow: false,
      other_image_params: {
        id: '',
        weighImage: [],
        billsImage: []
      }
    };
  },
  mounted: function mounted() {
    var _this = this;
    this.emptyFormData = JSON.parse(JSON.stringify(this.formData));
    Promise.all([new Promise(function (resolve, reject) {
      _this.$api[_this.pageConfig.dicTreeFunName](_this.dicData.sizeUpperCode).then(function (res) {
        if (res.data) {
          _this.dicData.configSizes = res.data;
          for (var i = 0; i < res.data.length; i++) {
            _this.dicData.configSizeOptions[res.data[i].code] = res.data[i].name;
          }
        }
        resolve(res);
      });
    }), new Promise(function (resolve, reject) {
      _this.$api[_this.pageConfig.mngConfigCacheValue]('service_fee_scale').then(function (res) {
        if (res.data) {
          _this.service_fee_scale = res.data;
        }
        resolve(res);
      });
    }), new Promise(function (resolve, reject) {
      _this.$api[_this.pageConfig.dicTreeFunName](_this.dicData.shapeUpperCode).then(function (res) {
        if (res.data) {
          _this.dicData.configShapes = res.data;
          for (var i = 0; i < res.data.length; i++) {
            _this.dicData.configShapeOptions[res.data[i].code] = res.data[i].name;
          }
        }
        resolve(res);
      });
    })]).then(function (result) {
      _this.query();
    });
  },
  watch: {
    placeDialogShow: function placeDialogShow(to) {
      if (!to) {
        this.place_params = {
          "firstPlaceFee": null,
          "secondPlaceFee": null,
          "thirdPlaceFee": null,
          "id": null
        };
      }
    }
  },
  methods: {
    xianghaoInput: function xianghaoInput(e) {
      console.log(e);
    },
    beforeCommand: function beforeCommand(index, row, command) {
      return {
        index: index,
        row: row,
        command: command
      };
    },
    moreButton: function moreButton(command) {
      switch (command.command) {
        case 'Undo':
          //撤单
          this.undo(command.row);
          break;
        case 'First_Place_Confirm':
          //到达提箱地
          this.firstConfirm(command.row);
          break;
        case 'Second_Place_Arrive':
          // 抵达卸货地
          this.secondArrive(command.row);
          this.submitConfirmData();
          break;
        case 'Second_Place_Confirm':
          //送货/装货确认
          this.secondConfirm(command.row);
          break;
        case 'Third_Place_Confirm':
          //已提箱确认
          this.thirdConfirm(command.row);
          break;
        case 'evaluate':
          //评价派单方
          this.evaluate(command.row);
          break;
        case 'cancel_transfer':
          //取消转单
          this.transferCancel(command.row);
          break;
        case 'transfer':
          //转单
          this.transfer(command.row);
          break;
        case 'Platform_Confirm':
          this.platformConfirm(command.row);
          break;
        case 'otherImages':
          this.otherImages(command.row);
          break;
      }
    },
    undo: function undo(_ref) {
      var _this2 = this;
      var id = _ref.id;
      this.$prompt('请填写撤单的原因', '撤单', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /^[\s\S]*.*[^\s][\s\S]*$/,
        inputErrorMessage: '请填写撤单原因'
      }).then(function (_ref2) {
        var value = _ref2.value;
        _this2.$api[_this2.pageConfig.undoFunName](id, {
          msg: value
        }).then(function (res) {
          _this2.$message.success('操作成功');
          _this2.query();
        });
      }).catch(function () {
        console.log('catch');
      });
    },
    firstConfirm: function firstConfirm(row) {
      var _this3 = this;
      this.dialogData = row;
      this.confirm_id = row.id;
      this.confirmDialogTitle = '到达提箱地';
      this.confirmFunName = this.pageConfig.firstPlaceFunName;
      this.confirmDialogShow = true;
      this.$api[this.pageConfig.detailFunName](row.waybillId).then(function (res) {
        _this3.dialogOrderData = res.data;
      });
      this.containerSealNums = [];
      if (!this.dialogData.containerSealNums) {
        for (var i = 0; i < row.containerAmount; i++) {
          this.containerSealNums.push({
            'identity': '',
            'sealIdentity': '',
            'ignore': false
          });
        }
      } else {
        this.containerSealNums = JSON.parse(this.dialogData.containerSealNums);
      }
    },
    secondArrive: function secondArrive(row) {
      var _this4 = this;
      this.dialogData = row;
      this.confirm_id = row.id;
      this.confirmDialogTitle = '抵达卸货地';
      this.confirmFunName = this.pageConfig.secondArriveFunName;
      this.$api[this.pageConfig.detailFunName](row.waybillId).then(function (res) {
        _this4.dialogOrderData = res.data;
      });
      this.containerSealNums = [];
      if (!this.dialogData.containerSealNums) {
        for (var i = 0; i < row.containerAmount; i++) {
          this.containerSealNums.push({
            'identity': '',
            'sealIdentity': '',
            'ignore': false
          });
        }
      } else {
        this.containerSealNums = JSON.parse(this.dialogData.containerSealNums);
      }
    },
    platformConfirm: function platformConfirm(row) {
      var _this5 = this;
      this.$api[this.pageConfig.platformConfim](row.id).then(function (res) {
        _this5.query();
      });
    },
    secondConfirm: function secondConfirm(row) {
      var _this6 = this;
      this.dialogData = row;
      this.confirm_id = row.id;
      this.confirmDialogTitle = '送货/装货确认';
      this.confirmFunName = this.pageConfig.secondPlaceFunName;
      this.confirmDialogShow = true;
      this.$api[this.pageConfig.detailFunName](row.waybillId).then(function (res) {
        _this6.dialogOrderData = res.data;
      });
      this.containerSealNums = [];
      if (!this.dialogData.containerSealNums) {
        for (var i = 0; i < row.containerAmount; i++) {
          this.containerSealNums.push({
            'identity': '',
            'sealIdentity': '',
            'ignore': false
          });
        }
      } else {
        this.containerSealNums = JSON.parse(this.dialogData.containerSealNums);
      }
    },
    thirdConfirm: function thirdConfirm(row) {
      var _this7 = this;
      this.dialogData = row;
      this.confirm_id = row.id;
      this.confirmDialogTitle = '已提箱确认';
      this.confirmFunName = this.pageConfig.thirdPlaceFunName;
      this.confirmDialogShow = true;
      this.$api[this.pageConfig.detailFunName](row.waybillId).then(function (res) {
        _this7.dialogOrderData = res.data;
      });
      this.containerSealNums = [];
      if (!this.dialogData.containerSealNums) {
        for (var i = 0; i < row.containerAmount; i++) {
          this.containerSealNums.push({
            'identity': '',
            'sealIdentity': '',
            'ignore': false
          });
        }
      } else {
        this.containerSealNums = JSON.parse(this.dialogData.containerSealNums);
      }
    },
    closeConfirmDialogShow: function closeConfirmDialogShow() {
      this.confirmDialogTitle = '';
      this.confirmDialogShow = false;
      this.initConfirmData(this.emptyFormData);
    },
    submitConfirmData: function submitConfirmData() {
      var _this8 = this;
      var data = {};
      var msg = '确定要取消转单吗';
      if (this.confirmDialogTitle == '到达提箱地') {
        data.firstPlaceFee = this.confirm_params.firstPlaceFee;
        data.firstPlaceImage = JSON.stringify(this.confirm_params.firstPlaceImage);
        msg = '确定到达提箱地吗';
        var _iterator = _createForOfIteratorHelper(this.containerSealNums.entries()),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var _step$value = _slicedToArray(_step.value, 2),
              index = _step$value[0],
              item = _step$value[1];
            if (!item.identity) {
              this.$message.error("\u8BF7\u8F93\u5165\u7BB1".concat(index + 1, "\u7BB1\u53F7"));
              return;
            }
            if (this.containerCategory != 'Special') {
              if (item.identity.length != 11) {
                this.$message.error("\u7BB1\u53F7\u5FC5\u987B\u4E3A11\u4F4D");
                return;
              }
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
      if (this.confirmDialogTitle == '抵达卸货地') {
        data = {};
        msg = '确定抵达卸货地吗';
      } else if (this.confirmDialogTitle == '送货/装货确认') {
        data.secondPlaceFee = this.confirm_params.firstPlaceFee;
        data.secondPlaceImage = JSON.stringify(this.confirm_params.firstPlaceImage);
        msg = '确定送货/装货确认吗';
        var _iterator2 = _createForOfIteratorHelper(this.containerSealNums.entries()),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var _step2$value = _slicedToArray(_step2.value, 2),
              _index = _step2$value[0],
              _item = _step2$value[1];
            if (!_item.identity) {
              this.$message.error("\u8BF7\u8F93\u5165\u7BB1".concat(_index + 1, "\u7BB1\u53F7"));
              return;
            }
            if (this.containerCategory != 'Special') {
              if (_item.identity.length != 11) {
                this.$message.error("\u7BB1\u53F7\u5FC5\u987B\u4E3A11\u4F4D");
                return;
              }
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      } else if (this.confirmDialogTitle == '已提箱确认') {
        data.thirdPlaceFee = this.confirm_params.firstPlaceFee;
        data.thirdPlaceImage = JSON.stringify(this.confirm_params.firstPlaceImage);
        msg = '确定已提箱确认吗';
        var _iterator3 = _createForOfIteratorHelper(this.containerSealNums.entries()),
          _step3;
        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var _step3$value = _slicedToArray(_step3.value, 2),
              _index2 = _step3$value[0],
              _item2 = _step3$value[1];
            if (!_item2.identity) {
              this.$message.error("\u8BF7\u8F93\u5165\u7BB1".concat(_index2 + 1, "\u7BB1\u53F7"));
              return;
            }
            if (this.containerCategory != 'Special') {
              if (_item2.identity.length != 11) {
                this.$message.error("\u7BB1\u53F7\u5FC5\u987B\u4E3A11\u4F4D");
                return;
              }
            }
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
      }
      this.$confirm(msg).then(function () {
        _this8.$api[_this8.confirmFunName](_this8.confirm_id, data).then(function (res) {
          if (res.data) {
            _this8.$api[_this8.pageConfig.modifyFunName](_this8.confirm_id, JSON.stringify(_this8.containerSealNums)).then(function (res) {
              if (res.data) {
                _this8.$message.success('操作成功');
                _this8.confirmDialogShow = false;
                _this8.query();
                _this8.confirm_params = {
                  firstPlaceFee: '',
                  firstPlaceImage: []
                };
              } else {
                _this8.$message.error('操作失败');
              }
            });
          } else {
            _this8.$message.error('操作失败');
          }
        });
      });
    },
    evaluate: function evaluate(data) {
      this.currentMerchant.merchantId = data.merchantId;
      this.currentMerchant.merchantUserId = data.merchantUserId;
      this.eval_show = true;
    },
    evalClose: function evalClose(val) {
      if (val) {
        this.query();
      }
      this.eval_show = false;
    },
    transferCancel: function transferCancel(_ref3) {
      var _this9 = this;
      var id = _ref3.id;
      this.$confirm('确定要取消转单吗').then(function () {
        _this9.$api[_this9.pageConfig.transferCancelFunName](id).then(function (res) {
          if (res.data) {
            _this9.$message.success('操作成功');
            _this9.query();
          } else {
            _this9.$message.error('操作失败');
          }
        });
      });
    },
    transfer: function transfer(_ref4) {
      var id = _ref4.id;
      this.transfer_id = id;
      this.driver_show = true;
    },
    otherImages: function otherImages(row) {
      this.otherImageDialogShow = true;
      this.other_image_params.id = row.id;
      this.other_image_params.weighImage = row.weighImage ? JSON.parse(row.weighImage) : [];
      this.other_image_params.billsImage = row.billsImage ? JSON.parse(row.billsImage) : [];
    },
    submitOtherImageData: function submitOtherImageData() {
      var _this10 = this;
      var data = {
        weighImage: JSON.stringify(this.other_image_params.weighImage),
        billsImage: JSON.stringify(this.other_image_params.billsImage)
      };
      this.$api[this.pageConfig.logisticHongdeWaybillOrderBillsAndImage](this.other_image_params.id, data).then(function (res) {
        if (res.code == 200) {
          _this10.$message.success('操作成功');
          _this10.otherImageDialogShow = false;
          _this10.tableData.forEach(function (item) {
            if (item.id == _this10.other_image_params.id) {
              item.weighImage = data.weighImage;
              item.billsImage = data.billsImage;
            }
          });
        } else {
          _this10.$message.error('操作失败');
        }
      });
    },
    driverClose: function driverClose(data) {
      var _this11 = this;
      if (data) {
        this.$api[this.pageConfig.transferFunName](this.transfer_id, data.id).then(function (res) {
          if (res.data) {
            _this11.$message.success('操作成功');
            _this11.query();
          } else {
            _this11.$message.error('操作失败');
          }
        });
      }
      this.driver_show = false;
    },
    placeFee: function placeFee() {
      this.$set(this.place_params, 'firstPlaceFee', this.waybillOrderDetailData.firstPlaceFee);
      this.$set(this.place_params, 'secondPlaceFee', this.waybillOrderDetailData.secondPlaceFee);
      this.$set(this.place_params, 'thirdPlaceFee', this.waybillOrderDetailData.thirdPlaceFee);
      this.placeDialogShow = true;
    },
    placeFormData: function placeFormData() {
      var _this12 = this;
      this.$api[this.pageConfig.placeFeeFunName](this.waybillOrderDetailData.id, this.place_params).then(function (res) {
        if (res.data) {
          _this12.$message.success('操作成功');
          _this12.$set(_this12.waybillOrderDetailData, 'firstPlaceFee', _this12.place_params.firstPlaceFee);
          _this12.$set(_this12.waybillOrderDetailData, 'secondPlaceFee', _this12.place_params.secondPlaceFee);
          _this12.$set(_this12.waybillOrderDetailData, 'thirdPlaceFee', _this12.place_params.thirdPlaceFee);
          _this12.placeDialogShow = false;
        } else {
          _this12.$message.error('操作失败');
        }
      });
    },
    initConfirmData: function initConfirmData(data) {
      var paramData = JSON.parse(JSON.stringify(data));
      this.confirm_params = paramData;
      if (typeof this.$refs['confirmDataVerify'] !== 'undefined') {
        this.$refs['confirmDataVerify'].clearValidate();
      }
    },
    beforeFileUpload: function beforeFileUpload(file) {
      var isImage = ['image/jpeg', 'image/jpg', 'image/png'].includes(file.type);
      if (!isImage) {
        this.$message.error('文件必须是图片格式');
      }
      var isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        this.$message.error('图片大小不超过5M！');
      }
      return isImage && isLt5M;
    },
    previewFile: function previewFile(path) {
      window.open(path);
    },
    removeImageFile: function removeImageFile(index) {
      this.confirm_params.firstPlaceImage.splice(index, 1);
    },
    removeWeighImageFile: function removeWeighImageFile(index) {
      this.other_image_params.weighImage.splice(index, 1);
    },
    removeBillsImageFile: function removeBillsImageFile(index) {
      this.other_image_params.billsImage.splice(index, 1);
    },
    uploadImage: function uploadImage(_ref5) {
      var _this13 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var file;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              file = _ref5.file;
              _this13.$api.aliOssSign(localStorage.getItem('userId')).then( /*#__PURE__*/function () {
                var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(res) {
                  var img;
                  return _regeneratorRuntime().wrap(function _callee$(_context) {
                    while (1) switch (_context.prev = _context.next) {
                      case 0:
                        _context.next = 2;
                        return _this13.uploadFile(localStorage.getItem('userId'), dayjs().format('YYYYMMDD'), res.data, file);
                      case 2:
                        img = _context.sent;
                        _this13.confirm_params.firstPlaceImage.push(img);
                      case 4:
                      case "end":
                        return _context.stop();
                    }
                  }, _callee);
                }));
                return function (_x) {
                  return _ref6.apply(this, arguments);
                };
              }());
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    otherImageWeighUploadImage: function otherImageWeighUploadImage(_ref7) {
      var _this14 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var file;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              file = _ref7.file;
              _this14.$api.aliOssSign(localStorage.getItem('userId')).then( /*#__PURE__*/function () {
                var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(res) {
                  var img;
                  return _regeneratorRuntime().wrap(function _callee3$(_context3) {
                    while (1) switch (_context3.prev = _context3.next) {
                      case 0:
                        _context3.next = 2;
                        return _this14.uploadFile(localStorage.getItem('userId'), dayjs().format('YYYYMMDD'), res.data, file);
                      case 2:
                        img = _context3.sent;
                        _this14.other_image_params.weighImage.push(img);
                      case 4:
                      case "end":
                        return _context3.stop();
                    }
                  }, _callee3);
                }));
                return function (_x2) {
                  return _ref8.apply(this, arguments);
                };
              }());
            case 2:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    otherImageBillsUploadImage: function otherImageBillsUploadImage(_ref9) {
      var _this15 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var file;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              file = _ref9.file;
              _this15.$api.aliOssSign(localStorage.getItem('userId')).then( /*#__PURE__*/function () {
                var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(res) {
                  var img;
                  return _regeneratorRuntime().wrap(function _callee5$(_context5) {
                    while (1) switch (_context5.prev = _context5.next) {
                      case 0:
                        _context5.next = 2;
                        return _this15.uploadFile(localStorage.getItem('userId'), dayjs().format('YYYYMMDD'), res.data, file);
                      case 2:
                        img = _context5.sent;
                        _this15.other_image_params.billsImage.push(img);
                      case 4:
                      case "end":
                        return _context5.stop();
                    }
                  }, _callee5);
                }));
                return function (_x3) {
                  return _ref10.apply(this, arguments);
                };
              }());
            case 2:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    },
    initFormData: function initFormData(data) {
      var paramData = JSON.parse(JSON.stringify(data));
      this.formData = paramData;
      if (typeof this.$refs['formDataVerify'] !== 'undefined') {
        this.$refs['formDataVerify'].clearValidate();
      }
    },
    back: function back() {
      this.$emit('child-go-waybill');
    },
    saveFormDataProcess: function saveFormDataProcess(formData) {
      var saveFormData = JSON.parse(JSON.stringify(formData));
      return saveFormData;
    },
    edit: function edit(id) {
      var _this16 = this;
      this.$api[this.pageConfig.detailOrderFunName](id).then(function (res) {
        _this16.initFormData(res.data);
        _this16.editDialogTitle = _this16.pageConfig.editPageName + '铅封号维护';
        _this16.containerSealNums = JSON.parse(_this16.waybillOrderDetailData.containerSealNums);
        _this16.editDialogShow = true;
      });
    },
    feeConfirm: function feeConfirm(id) {
      var _this17 = this;
      this.$confirm('确定服务费已收取吗？').then(function () {
        _this17.$api[_this17.pageConfig.waybillOrderConfirmFunName](id).then(function (res) {
          if (res.code == 200) {
            _this17.$message.success('收取成功');
            _this17.query();
          } else {
            _this17.$message.error('收取失败');
          }
        });
      });
    },
    rowDetail: function rowDetail(data) {
      var _this18 = this;
      this.waybillOrderDetailData = data;
      // 司机
      if (data.driverId) {
        this.$api[this.pageConfig.driverDetailFunName](data.driverId).then(function (driverRes) {
          _this18.driverDetailData = driverRes.data;
        });
      }
      this.getDetail(data.waybillId);
      this.detailDialogShow = true;
    },
    query: function query() {
      var _this19 = this;
      this.queryLoading = true;
      this.$api[this.pageConfig.queryFunName](this.processSearchForm()).then(function (res) {
        _this19.tableData = res.data || [];
        _this19.totalCount = res.count;
        _this19.queryLoading = false;
      });
      this.$api[this.pageConfig.totalFeeFunName](this.processSearchForm()).then(function (res) {
        _this19.totalFeeFormData = res.data;
      });
    },
    processSearchForm: function processSearchForm() {
      var commitSearchForm = JSON.parse(JSON.stringify(this.searchForm));
      return commitSearchForm;
    },
    exportData: function exportData() {
      var requestUrl = process.env.VUE_APP_API + 'logistics_hongde/waybillOrder/basisExportJoinWaybillAndDriver';
      var searchParams = this.processSearchForm();
      searchParams.Authorization = localStorage.getItem('token');
      window.open(requestUrl + this.joinGetParam(searchParams), '_blank');
    },
    getDetail: function getDetail(id) {
      var _this20 = this;
      this.queryLoading = true;
      this.$api[this.pageConfig.detailFunName](id).then(function (res) {
        _this20.waybillDetailData = res.data;

        // 船公司
        if (res.data.shipCompanyId) {
          _this20.$api[_this20.pageConfig.shipCompanyDetailFunName](res.data.shipCompanyId).then(function (shipCompanyRes) {
            // this.waybillDetailData.shipCompanyId = shipCompanyRes.data.code || this.waybillDetailData.shipCompanyId
            // this.waybillDetailData.shipRemark = shipCompanyRes.data.remark || ''
            _this20.$set(_this20.waybillDetailData, 'shipCompanyId', shipCompanyRes.data.code || _this20.waybillDetailData.shipCompanyId);
            _this20.$set(_this20.waybillDetailData, 'shipCompanyName', shipCompanyRes.data.name || '');
            _this20.$set(_this20.waybillDetailData, 'shipRemark', shipCompanyRes.data.remark || '');
          });
        }

        // 车队
        if (res.data.specifyCarTeamIds) {
          var carTeamNames = '';
          var carTeamIdJson = JSON.parse(res.data.specifyCarTeamIds);
          for (var i = 0; i < carTeamIdJson.length; i++) {
            if (i !== 0) {
              carTeamNames += '、';
            }
            carTeamNames += carTeamIdJson[i].name;
          }
          res.data.specifyCarTeamIds = carTeamNames;
        }
        _this20.queryLoading = false;
      });
    },
    submitFormData: function submitFormData() {
      var _this21 = this;
      var _iterator4 = _createForOfIteratorHelper(this.containerSealNums),
        _step4;
      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var item = _step4.value;
          if (!item.identity) {
            this.$message.info('请填写箱号');
            return;
          }
          if (this.waybillDetailData.containerEmptyOrFull == 'Full' && !item.sealIdentity) {
            this.$message.info('请填写铅封号');
            return;
          }
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
      this.$api[this.pageConfig.modifyFunName](this.waybillOrderDetailData.id, {
        containerSealNums: JSON.stringify(this.containerSealNums)
      }).then(function (res) {
        if (res.data) {
          _this21.$message.success('操作成功');
          _this21.editDialogShow = false;
          _this21.detailDialogShow = false;
          _this21.query();
        } else {
          _this21.$message.error('操作失败');
        }
      });
    },
    closeEditDialogShow: function closeEditDialogShow() {
      this.editDialogTitle = '';
      this.editDialogShow = false;
      this.initFormData(this.emptyFormData);
    },
    reset: function reset() {
      this.searchForm = {
        page: 1,
        limit: 10,
        searchKey: null,
        sortField: 'create_time',
        merchantNickname: null,
        driverContactPhone: null,
        waybillDeliveryMode: null,
        starDate: null,
        endDate: null,
        orderState: null
      };
      this.query();
    },
    search: function search() {
      this.searchForm.page = 1;
      this.query();
    },
    pageChange: function pageChange(page) {
      this.searchForm.page = page;
      this.query();
    },
    sizeChange: function sizeChange(limit) {
      this.searchForm.page = 1;
      this.searchForm.limit = limit;
      this.query();
    },
    sortChange: function sortChange(column) {
      this.searchForm.page = 1;
      this.searchForm.sortField = column.order === 'ascending' ? '^' + this.camelToUnderline(column.prop) : column.order === 'descending' ? this.camelToUnderline(column.prop) : 'create_time';
      this.query();
    }
  }
};